import { newSquadModalStore } from '../../stores';

/**
 * @description
 * open modal add new squad
 */
export const openNewSquadModal = (id: string) => {
  newSquadModalStore.setValue({ isOpen: true, id });
};
